import { createContext } from "react";
import { getDefaultStateConfig } from "./getDefaultStateConfig";
import { StateConfigState } from "./types";

export const StateConfigContext = createContext<StateConfigState>(
  getDefaultStateConfig()
);

export default StateConfigContext;
